import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import { BasicSelect } from 'vue-search-select';
import user_tracker from '../../../../usertracker'

export default {
  name: 'GroupConnectionMapping',
  components: {
    BasicSelect,
    VueElementLoading,
    Multiselect
  },
  data: function () {
    return {
      useremail: '',
      cityList: [],
      parentHubList: [],
      destinationcityObjData: {
        value: "",
        text: ""
      },
      destinationcityid: '',
      destinationcityname: '',
      isLoading: false,
      parentHub: '',
      allBagTypes: [],
      connectionlist: [],
      groupTypeObjData: {
        value: "",
        text: ""
      },
      groupList: [],
      selectedbagtype: '',
      selectedBag: '',
      connectionDestList: [],
      resultCount: 0,
      groupid: '',
      checkAllHub: false,
      parentHubObjData: {
        id: "",
        hubname: ""
      },
      groupConnectionStatusModal: false,
      showHubsModal: false,
      hubStatusModal: false,
      changestatusHub: '',
      mappedHUbsList: [],
      baggingpattern: false,
      connectiongroupmappingid: '',
      selectedBagTypes: '',
      mappedHubCount: 0,
      isselected: false,
      isLoadingtable: false,
      cityLoading: '',
      groupDisplayName: '',
      confirmationModal: false,
      bagTypeError: '',
      parentHubError: '',
      userData:[],
      showReplicationOption: false,
      replicableGroups: [],
      selectedSourceGroup: null,
      isLoadingReplication: false
    }
  },

  created: function () { },
  computed: {},

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.useremail = userdetail[0].email;
    this.getCityList();
  },
  methods: {
    selectedDestination(cityData) {
      this.groupTypeObjData = {};
      this.destinationcityObjData = cityData
      this.destinationcityid = cityData.value
      this.destinationcityname = cityData.text
      if (this.destinationcityid != "") {
        this.connectionDestList = [];
        this.parenthublist = [];
        this.allBagTypes = [];
        this.showReplicationOption = false;
        this.selectedSourceGroup = null;
        this.replicableGroups = [];
        this.getCitywiseGroups();
      }
    },

    selectedGroupType(groupTypeData) {
      this.groupTypeObjData = groupTypeData;
      this.groupid = groupTypeData.value;
      this.groupDisplayName = groupTypeData.text;
      if (this.groupid != '') {
        this.parenthublist = [];
        this.allBagTypes = [];
        this.connectionDestList = [];
        this.showReplicationOption = false;
        this.selectedSourceGroup = null;
        this.replicableGroups = [];
        this.getBagTypeAndParentHub();
      }
    },

    selectedBagType(bagData) {
      this.bagTypeError = ''
    },

    selectParentHub() {
      this.parentHubError = ''
    },

    getCityList() {
      this.isLoading = false;
      var i = 0;
      this.resultCount = 0;
      this.input = ({})
      this.cityLoading = 'Loading City...';
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'allcity/get',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          var cityList = result.data.ResponseData
          for (i = 0; i < cityList.length; i++) {
            this.cityList.push({
              value: cityList[i].cityid,
              text: cityList[i].cityname
            })
          }
          this.isLoading = false;
          this.cityLoading = '';
        }, error => {
          this.isLoading = false;
          this.cityLoading = '';
          console.error(error)
        })
    },

    //get city wise groups
    getCitywiseGroups() {
      this.groupTypeObjData = {};
      this.groupList = [];
      var i = 0;
      this.isLoading = true;
      axios({
        method: 'GET',
        // legacy backup: getGroupfromCity
        // 'url': apiUrl.api_url_hubops + 'getGroupfromCity?cityId=' + this.destinationcityid,
        'url': apiUrl.api_url_hubops + 'groups?cityId=' + this.destinationcityid + '&isActive=true',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            var groupList = result.data.ResponseData
            for (i = 0; i < groupList.length; i++) {
              this.groupList.push({
                value: groupList[i].groupid,
                text: groupList[i].groupname + ' - ' + groupList[i].routemode + ' - ' + groupList[i].groupno
              })
            }
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },

    //get group wise bagtype and parent hub and connecttion list
    getBagTypeAndParentHub() {
      this.allBagTypes = [];
      this.isLoading = true;
      this.selectedBagTypes = '';
      this.parentHub = '';
      this.checkAllHub = false;
      this.connectionDestList = [];
      var i = 0;
      this.input = ({})
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'getGroupConnectionDetails?groupid=' + this.groupid + '&cityid=' + this.destinationcityid,
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            var allBagTypes = result.data.ResponseData.bagtypes;
            this.parentHubList = result.data.ResponseData.parenthubs;
            var connectionlist = result.data.ResponseData.connectionlist;

            if (allBagTypes.length != 0) {
              for (i = 0; i < allBagTypes.length; i++) {
                this.allBagTypes.push({
                  id: i,
                  text: allBagTypes[i]
                })
              }
            }
            if (this.parentHubList.length == 1) {
              this.parentHub = this.parentHubList[0];
            }
            if (connectionlist.length != 0) {
              this.connectionDestList = connectionlist
              let allsectedconn = this.connectionDestList.filter(item => item.isselected)
              if (allsectedconn.length == this.connectionDestList.length) {
                this.checkAllHub = true;
                this.showReplicationOption = false;
              } else if(allsectedconn.length == 0){
                // Show replication option when connections exist but none selected
                this.showReplicationOption = true;
                this.getReplicableGroups();
              } else {
                this.showReplicationOption = false;
              }
            }
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },

    checkHub() {
      if (this.checkAllHub) {
        for (var i = 0; i < this.connectionDestList.length; i++) {
          this.connectionDestList[i].isselected = true
        }
      } else {
        for (var i = 0; i < this.connectionDestList.length; i++) {
          this.connectionDestList[i].isselected = false
        }
      }
    },

    //change status Active to Deactive for hubs connection on group
    changeGroupConnectionStatus() {
      if (this.changestatus == 'De-Activate') {
        var newStatus = false;
      } else {
        var newStatus = true;
      }
      this.input = ({
        connectiongroupmappingid: this.connectiongroupmappingid,
        groupId: this.groupSearch,
        cityId: this.citySearch,
        originHubId: this.originHubIdStatus,
        isActive: newStatus,
        createdBy: this.useremail,
      })
      axios({
        method: 'PUT',
        'url': apiUrl.api_url_hubops + 'deAllocateConnectionGroupMapping',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then((result) => {
          this.getGroupConnectionList();
          if (result.data.ResultCode == 100) {
            this.$alert('Template Status Changed Successfully', "", "success");
            user_tracker.checkUserIP(this.userData[0], "GroupConnectionMapping", this.$route.path , this.input);
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.groupConnectionStatusModal = false;
        })
        .catch((Exception) => {
          console.error('exception is:::::::::', Exception)
        })
    },

    //getting mapped hubs on connections
    getHubMappedListData(data) {
      this.connectiongroupmappingid = data.connectiongroupmappingid;

      if (data.isselected == false || !data.connectiongroupmappingid) {
        this.$alert('Please Select the Mapped Connection To Change The Mapped Hub Status', "", "error");
        return false;
      }

      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'getMappedDestionList?connectionGroupMappingId=' + data.connectiongroupmappingid + '&groupid=' + this.groupid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.showHubsModal = true;
            this.mappedHUbsList = result.data.ResponseData;
            this.mappedHubCount = result.data.ResponseData.length;
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },

    closeStatusGroupModal() {
      this.groupConnectionStatusModal = false;
    },
    closeModal() {
      this.confirmationModal = false;
    },
    getStatusHublistData(data) {
      this.hubStatusModal = true;
      this.showHubsModal = false;
      this.connectionGroupMappingIdStatus = data.connectiongroupmappingid
      this.groupId = data.groupid
      this.destinationHubId = data.destinationhubid

      if (data.isactive == true) {
        this.changestatusHub = 'De-Activate'
      } else {
        this.changestatusHub = 'Activate'
      }
    },

    changeMappedHubStatus() {
      this.isLoading = true;
      if (this.changestatusHub == 'De-Activate') {
        var newStatus = false;
      } else {
        var newStatus = true;
      }
      this.input = ({
        connectionGroupMappingId: this.connectiongroupmappingid,
        groupId: this.groupid,
        destinationHubId: this.destinationHubId,
        isActive: newStatus,
        createdBy: this.useremail
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'updateDestinationStatus',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then((result) => {
          if (result.data.ResultCode == 100) {
            this.$alert('Hub Status Changed Successfully', "", "success");
            user_tracker.checkUserIP(this.userData[0], "GroupConnectionMapping", this.$route.path , this.input);
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.hubStatusModal = false;
          this.showHubsModal = false;
          this.isLoading = false;
        })
        .catch((Exception) => {
          this.isLoading = false;
          console.error('exception is:::::::::', Exception)
        })
    },

    closeHubsModal() {
      this.showHubsModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },

    closeStatusHubModal() {
      this.hubStatusModal = false;
    },

    //Update the connections in save button
    mapMultipleHubsToConnection() {
      this.confirmationModal = false;
      this.selectedBagTypes = [...new Set(this.selectedBag.map(a => a.text))];
      this.isLoadingtable = true;
      let connectionlist = this.connectionDestList.filter(function (i) {
        return i.isselected;
      }).map(function (i) {
        return { connectionid: i.connectionid, connectionname: i.connectionname, isbaggingpattern: i.isbaggingpattern ? i.isbaggingpattern : false };
      });

      this.input = {
        cityid: this.destinationcityid,
        cityname: this.destinationcityname,
        groupid: this.groupid,
        parenthubid: this.parentHub.hubid,
        parenthubname: this.parentHub.hubname,
        bagtypes: this.selectedBagTypes.join(','),
        connectionlist: connectionlist,
        createdby: this.useremail
      }

      axios({
        method: 'PUT',
        'url': apiUrl.api_url_hubops + "saveGroupConnectionDetails",
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          this.isLoadingtable = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            user_tracker.checkUserIP(this.userData[0], "GroupConnectionMapping", this.$route.path , this.input);
            this.resetForm();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          this.isLoadingtable = false;
          console.error(error)
        })
    },

    onSubmitHub: function (elem) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.selectedBag.length <= 0 || !this.parentHub) {
            this.bagTypeError = (this.selectedBag.length <= 0) ? 'Bag Type Field is Required' : ' ';
            this.parentHubError = (!this.parentHub) ? 'Parent Hub Field is Required' : ' ';
            window.scrollBy(0, -1000);
            return false;
          }
          this.confirmationModal = true;
        } else {
          console.log('save error'); return false;
        }
      }).catch(() => { });
    },

    resetForm() {
      this.connectionDestList = [];
      this.parentHubList = [];
      this.allBagTypes = [];
      this.connectionlist = [];
      this.isLoading = false;
      this.resultCount = 0;
      this.groupid = '';
      this.groupTypeObjData = {
        value: "",
        text: ""
      };
      this.destinationcityObjData = {
        value: "",
        text: ""
      };
      this.parentHub = '';
      this.selectedBagTypes = '';
      this.selectedBag = '';
      this.destinationcityid = '';
      this.checkAllHub = false;
      this.destinationcityid = '';
      this.mappedHubCount = 0;
      this.isselected = false;
      this.isLoadingtable = false;
      this.cityLoading = '';
      this.parentHub = '';
      this.groupDisplayName = '';
      this.confirmationModal = false;
      this.showReplicationOption = false;
      this.selectedSourceGroup = null;
      this.replicableGroups = [];
      this.isLoadingReplication = false;
      this.$validator.reset();
    },

    updateselected() {
      this.checkAllHub = false;
      let selectedrecords = this.connectionDestList.filter(item => item.isselected)
      if (selectedrecords.length == this.connectionDestList.length) {
        this.checkAllHub = true;
      }
    },

    // Get groups with same grouptype and routemode for replication
    getReplicableGroups() {
      this.isLoadingReplication = true;
      this.replicableGroups = [];
      
      axios({
        method: 'GET',
        // legacy backup: getReplicableGroups
        // url: apiUrl.api_url_hubops + 'getReplicableGroups?groupid=' + this.groupid,
        url: apiUrl.api_url_hubops + 'groups?replicateFromGroupId=' + this.groupid,
        headers: { 'authorization': 'authkey xB84JJ89Hd25' }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          this.replicableGroups = result.data.ResponseData.map(group => ({
            value: group.groupid,
            text: `${group.groupname} - ${group.routemode} - ${group.groupno}`
          }));
        } else if (result.data.ResultCode == 101) {
          // No replicable groups found - hide option
          this.showReplicationOption = false;
        } else {
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.isLoadingReplication = false;
      })
      .catch(error => {
        this.isLoadingReplication = false;
        this.showReplicationOption = false;
        console.error(error);
      });
    },

    // Replicate connections from selected source group
    replicateFromGroup() {
      if (!this.selectedSourceGroup) return;
      
      this.isLoadingReplication = true;
      
      // Use existing getGroupConnectionDetails API for source group
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getGroupConnectionDetails?groupid=' + 
             this.selectedSourceGroup.value + '&cityid=' + this.destinationcityid,
        headers: { 'authorization': 'authkey xB84JJ89Hd25' }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          let sourceConnectionList = result.data.ResponseData.connectionlist;
          
          // Filter only active connections (isselected: true)
          let activeSourceConnections = sourceConnectionList.filter(conn => conn.isselected === true);
          
          // Auto-select matching connections in target group
          this.connectionDestList.forEach(targetConnection => {
            let matchedConnection = activeSourceConnections.find(
              sourceConn => sourceConn.connectionid === targetConnection.connectionid
            );
            
            if (matchedConnection) {
              // Auto-select connection checkbox
              targetConnection.isselected = true;
              
              // Copy bagging pattern setting
              targetConnection.isbaggingpattern = matchedConnection.isbaggingpattern;
              
              // DO NOT copy bagtypes - user must select manually from dropdown
            }
          });
          
          // Update UI state
          this.updateselected();
          this.showReplicationOption = false;
          
          this.$alert(
            `Successfully replicated ${activeSourceConnections.length} connections. Please select Bag Type and Parent Hub before saving.`, 
            "", 
            "success"
          );
          user_tracker.checkUserIP(this.userData[0], "GroupConnectionMapping-Replication", this.$route.path, {
            sourceGroupId: this.selectedSourceGroup.value,
            targetGroupId: this.groupid,
            replicatedCount: activeSourceConnections.length
          });
        } else {
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.isLoadingReplication = false;
      })
      .catch(error => {
        this.isLoadingReplication = false;
        console.error(error);
        this.$alert("Error replicating connections", "", "error");
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/ConnectionGroupMapping/ConnectionGroupMapping.js